<div class="drag-drop-container">
  <mat-card class="persona-list-card">
    <mat-card-title class="list-title unused-title">Available Personas</mat-card-title>
    <mat-list
      cdkDropList
      [cdkDropListData]="unusedPersonas"
      [cdkDropListConnectedTo]="['cdkDropList-used']"
      (cdkDropListDropped)="drop($event)"
      id="cdkDropList-unused"
      class="persona-list">
      @for (persona of unusedPersonas; track persona.id) {
        <mat-list-item cdkDrag [cdkDragDisabled]="disabled" class="persona-item">
          <mat-icon matListItemIcon color="accent">drag_indicator</mat-icon>
          <div matListItemTitle>{{ persona.name }}</div>
        </mat-list-item>
      }
    </mat-list>
  </mat-card>

  <mat-card class="persona-list-card">
    <mat-card-title class="list-title used-title">Selected Personas</mat-card-title>
    <mat-list
      cdkDropList
      [cdkDropListData]="usedPersonas"
      [cdkDropListConnectedTo]="['cdkDropList-unused']"
      (cdkDropListDropped)="drop($event)"
      id="cdkDropList-used"
      class="persona-list used-list">
      @for (persona of usedPersonas; track persona.id) {
        <mat-list-item cdkDrag [cdkDragDisabled]="disabled" class="persona-item">
          <mat-icon matListItemIcon color="accent">drag_indicator</mat-icon>
          <div matListItemTitle>{{ persona.name }}</div>
        </mat-list-item>
      }
    </mat-list>
  </mat-card>
</div>
